const state = {
  all: [],
  producao: {},
  desempenho: {},
  tag: {},
  tabela: {},
  tabeladesempenho: {}
}

const mutations = {
  fillDataRelatorio (state, res) {
    state.producao = res.data
  },
  fillDataRelatorioTag (state, res) {
    state.tag = res.data.grafico
    state.tabela = res.data.tabela
  },
  fillDataRelatorioPedidosTempo (state, res) {
    state.desempenho = res.data.grafico
    state.tabeladesempenho = res.data.tabela
  }
}

const actions = {
  createRelatorioProducao(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v2/relatorios/producao', data).then((res) => {
      context.commit('fillDataRelatorio', res)
      return res
    })
  },
  createRelatorioProducaoTag(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v2/relatorios/producao/tag', data).then((res) => {
      context.commit('fillDataRelatorioTag', res)
      return res
    })
  },
  createRelatorioProducaoPedidosTempo(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v2/relatorios/desempenho', data).then((res) => {
      context.commit('fillDataRelatorioPedidosTempo', res)
      return res
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Relatorios.js